// src/utils/siteConfigCache.js

let cachedHeader = null;
let cachedFooter = null;

export const getCachedHeader = () => cachedHeader;
export const setCachedHeader = (data) => { cachedHeader = data; };

export const getCachedFooter = () => cachedFooter;
export const setCachedFooter = (data) => { cachedFooter = data; };
